// @ts-strict-ignore
import {
  Box, Button, Icon, IconName,
} from '@usealloy/component-library';
import React, { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import type { Document } from '~/entities/types';
import { ajaxFetch } from '~/helpers/api';

interface Props {
  document: Document;
  previewMode?: boolean;
}

export const DocumentRenderer: React.FC<Props> = ({
  document,
  previewMode = false,
}) => {
  const {
    content_type: contentType,
    name,
    url,
  } = document;

  const [docHtmlContent, setDocHtmlContent] = useState<string>(null);
  useEffect(() => {
    if (contentType && contentType.includes('html')) {
      ajaxFetch(url, { json: false }).then(data => { setDocHtmlContent(data); });
    }
  }, [contentType, url]);

  if (contentType) {
    if (contentType.includes('image/')) {
      return (
        <img
          alt={name}
          src={url}
          style={{ width: '80%', maxWidth: 600, maxHeight: '100%' }}
        />
      );
    }

    if (contentType.includes('video/')) {
      if (previewMode) {
        return (
          <Icon icon={IconName.Video} size="xl" />
        );
      }
      return (
        <video
          controls
          src={url}
          style={{ maxWidth: '80%', maxHeight: '100%' }}
        >
          Your browser does not support the video tag.
        </video>
      );
    }

    if (contentType.includes('pdf')) {
      if (previewMode) {
        return (
          <Icon icon={IconName.Pdf} size="xl" />
        );
      }
      return (
        <>
          <a href={url} target="_blank" rel="noreferrer">
            full screen
          </a>
          <iframe src={url} width="80%" height="600px" />
        </>
      );
    }

    if (contentType.includes('text/html')) {
      if (docHtmlContent) {
        return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(docHtmlContent) }} />;
      }
    }
  }

  // =====  FALLTHROUGH CASES  =====
  if (previewMode) {
    return <Icon icon={IconName.Document} />;
  }

  return (
    <Box direction="column" gap={4}>
      <p>Document {name} could not be displayed</p>
      <p>Please download in order to view</p>
      <a
        href={document.url}
        target="_blank"
        className="secondary inline"
        download={`${document.name}.${document.extension}`}
        rel="noreferrer"
      >
        <Button>
          <Icon icon={IconName.Download} />
          Download
        </Button>
      </a>
    </Box>
  );
};
